export type TZ = "utc" | "local";

const pad = (n: number) => String(n).padStart(2, "0");

/** Full datetime: "2026-05-28 14:30:00 UTC" or "2026-05-28 10:30:00" */
export function formatTime(ms: number, tz: TZ): string {
  const d = new Date(ms);
  if (tz === "utc") {
    return (
      `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())} ` +
      `${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:${pad(d.getUTCSeconds())} UTC`
    );
  }
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
    `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
  );
}

/** Date only: "2026-05-28" */
export function formatDate(ms: number, tz: TZ): string {
  const d = new Date(ms);
  if (tz === "utc") {
    return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}`;
  }
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** Time only: "14:30:00 UTC" or "10:30:00" */
export function formatTimeShort(ms: number, tz: TZ): string {
  const d = new Date(ms);
  if (tz === "utc") {
    return `${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:${pad(d.getUTCSeconds())} UTC`;
  }
  return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

/** Format epoch ms as a datetime-local input value (YYYY-MM-DDTHH:MM) in the given tz. */
export function msToDatetimeInput(ms: number, tz: TZ): string {
  const d = new Date(ms);
  if (tz === "utc") {
    return (
      `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}` +
      `T${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}`
    );
  }
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` +
    `T${pad(d.getHours())}:${pad(d.getMinutes())}`
  );
}

/** Parse a datetime-local string back to epoch ms, interpreting it as utc or local. */
export function datetimeInputToMs(value: string, tz: TZ): number | undefined {
  if (!value) return undefined;
  const ms = tz === "utc"
    ? new Date(value + ":00Z").getTime()
    : new Date(value + ":00").getTime();
  return isNaN(ms) ? undefined : ms;
}
